import React, { Component } from 'react'
import styled from 'styled-components'
import { Shape, XMText, Icon } from './'

const StyledShape = styled(Shape)`
  position: relative;
  &:after {
    content: '';
    position: absolute;
    background: #fff;
    width: 6px;
    height: 6px;
    border-left: 1px solid #ff0000;
    border-top: 1px solid #ff0000;
    transform: rotate(225deg);
    right: calc(100% - 70px);
    bottom: -4px;
  }
  ${props =>
    props.type === 'default' &&
    `
    border:none;
    background-color: #124b5f;
    min-width: 60px;
    &:after {
      content: '';
      position: absolute;
      background: #124b5f;
      width: 6px;
      height: 6px;
      border-left: none;
      border-top: none;
      transform: rotate(225deg);
      right: 0;
      left: calc(100% - 50px);
      bottom: -3px;
    }
    &>p{
      font-size: 11px;
      font-weight: bold;
      line-height: 1.55;
      color: #ffffff;
      
    }
    &>svg{
      display: none;
    }
  `};
  ${props =>
    props.forProductView &&
    `
    width: 35px;
    padding: 4px;
    &:after {
    content: '';
    position: absolute;
    background: #fff;
    width: 6px;
    height: 6px;
    border-left: 1px solid #ff0000;
    border-top: 1px solid #ff0000;
    transform: rotate(225deg);
    right:auto;
    bottom: -4px;
  }
  &>svg{
    margin-right: 0;
  }
  `};
`
class Tooltip extends Component {
  state = {}
  render() {
    const { content = 'Dietary Warning', type, padding, forProductView, ...props } = this.props
    return (
      <StyledShape
        display="inline-flex"
        padding={padding ? padding : '3px 8px'}
        backgroundColor="rgba(252, 213, 213, 0.22)"
        border="1px solid #ff0000"
        justifyContent="center"
        type={type}
        forProductView={forProductView}
        {...props}>
        <Icon icon="warning" />
        {forProductView ? null : <XMText color="#ff0000">{content}</XMText>}
      </StyledShape>
    )
  }
}

export default Tooltip



// WEBPACK FOOTER //
// ./src/components/Tooltip.js